module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0034.0e03ccca.jpg";